import SplashScreen from "../../../helpers/SplashScreen"

const GraphModulePreloader: React.FC = props => {
    return <div className="moduleWidgets_widgetGraphModule">
        <SplashScreen active className="default" />
    </div>
}

export default GraphModulePreloader